import { ValidationErrors } from '@angular/forms';

export const getErrorMessage = (errors: ValidationErrors): string => {
  const errorsList = Object.keys(errors);
  const [errorKey] = errorsList.includes('matDatepickerParse')
    ? ['matDatepickerParse']
    : Object.entries(errors).shift();

  switch (errorKey) {
    case 'required':
      return 'Required';
    case 'emailInvalid':
      return 'Invalid email';
    case 'phoneInvalid':
      return 'Invalid Format';
    case 'timeInPast':
      return 'Time cannot be in the past';
    case 'matDatepickerMin':
      return 'Date cannot be in the past';
    case 'matDatepickerMax':
      return 'Date cannot be in the future';
    case 'matDatepickerParse':
      return 'Invalid date format';
  }
};
